/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {Link} from 'react-router-dom'
import {useAuth} from '../../../../app/modules/auth'
import {toAbsoluteUrl} from '../../../helpers'
import {getBadgeRole} from 'app/utils/role'
import {useChangePasswordModal} from 'app/components/Ops/ChangePassword'

const HeaderUserMenu: FC = () => {
  const {logout, getUser} = useAuth()
  var user = getUser()
  const {showModal} = useChangePasswordModal()

  const handleChangePassword = () => {
    showModal()
  }

  return (
    <div className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-350px' data-kt-menu='true'>
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-start px-3'>
          <div className='symbol symbol-50px me-5'>
            <img alt='Logo' src={toAbsoluteUrl('/media/avatars/300-1.jpg')} />
          </div>

          <div className='d-flex flex-column'>
            <div className='fw-bolder d-flex align-items-center fs-5'>{user?.fullname ?? user?.application_username}</div>
            {user?.email_address && (
              <a href='#' className='fw-bold text-muted text-hover-primary fs-7 mb-2'>
                {user?.email_address ?? '-'}
              </a>
            )}
            {user && <div className='d-flex-inline mt-2'>{getBadgeRole(user)}</div>}
          </div>
        </div>
      </div>

      <div className='separator my-2'></div>

      {/* <div className='menu-item px-5'>
        <Link to={'/user/profile'} className='menu-link px-5'>
          My Profile
        </Link>
      </div> */}
      <div className='menu-item px-5'>
        <p className='menu-link px-5 mb-0' onClick={handleChangePassword}>
          Ganti Password
        </p>
      </div>

      {/* <div className='menu-item px-5'>
        <a href='#' className='menu-link px-5'>
          My Statements
        </a>
      </div> */}

      {/* <div className='separator my-2'></div> */}

      {/* <div className='menu-item px-5 my-1'>
        <Link to='/crafted/account/settings' className='menu-link px-5'>
          Account Settings
        </Link>
      </div> */}

      <div className='menu-item px-5'>
        <a onClick={() => logout()} className='menu-link px-5'>
          Logout
        </a>
      </div>
    </div>
  )
}

export {HeaderUserMenu}
